export default __webpack_public_path__ + "static/Pala_16-bc98af79e63d152460901b240be70b09.png";